import React, {useEffect, useState} from "react";
import {CategoryBody, FakeTabelBody, StyledMenuManagementAccor, TableRowsWrapper} from "./MenuManagement.styles";
import {TiArrowSortedUp} from "react-icons/ti";
import handel from "assets/dragHandel.svg";
import deleteIcon from "assets/menu-delete.svg";
import {arrayMove, sortableContainer, sortableElement, sortableHandle} from "react-sortable-hoc";
import Button from "components/molecules/Button";
import {FaRegEdit} from "react-icons/fa";
import ModalContainer from "components/molecules/ModalContainer";
import AddNewItem from "components/atoms/MenuManagement/AddNewItem/Index";
import AddCategory from "components/atoms/MenuManagement/CategoryModal";
import DeleteModal from "components/atoms/DeleteModal/Index";
import {useAuthContext} from "Context/authContext";
import Toast from "components/molecules/Toast";
import menuStoreService from "services/menu-storeService";
import {convertArrayToString, truncateString} from "helpers/common";

const MenuManagementAccor = ({setSelected, selected, rowData, ind, handelSelected, menuId, handelApi}) => {
    const {refetch} = useAuthContext();
    const [product, setProduct] = useState();
    const {hasPermission} = useAuthContext("hasPermission");
    useEffect(() => {
        setProduct(rowData?.menuItems);
    }, [rowData]);

    const Items = ({item}) => (
        <div className="fake-table-resp">
            <span className="thead-row">Items</span>
            <div className="CategroyName fake-td ">
                <img src={item?.itemImage} alt={item?.name} width={34} height={36} />
                <span className="itemsName">{item?.name}</span>
            </div>
        </div>
    );
    const Description = ({item}) => (
        <div className="fake-table-resp">
            <span className="thead-row">Description</span>
            <div className="Description fake-td ">
                <p>{truncateString(item?.description)}</p>
            </div>
        </div>
    );
    const Variation = ({item}) => (
        <div className="fake-table-resp">
            <span className="thead-row">Variation</span>
            <div className="variation fake-td ">
                <p>{convertArrayToString(item?.variations, "variationName")}</p>
            </div>
        </div>
    );
    const Choices = ({item}) => (
        <div className="fake-table-resp">
            <span className="thead-row">Choice group</span>
            <div className="choices fake-td ">
                <p>{convertArrayToString(item?.groupChoices, "groupName")}</p>
            </div>
        </div>
    );

    const Status = ({item}) => {
        switch (item.availability) {
            case true:
                return (
                    <div className="fake-table-resp">
                        <span className="thead-row">Status</span>
                        <div className="success fake-td"> Available</div>
                    </div>
                );

            default:
                return (
                    <div className="fake-table-resp">
                        <span className="thead-row">Status</span>
                        <div className="danger fake-td"> Unavailable</div>
                    </div>
                );
        }
    };
    const Offer = ({item}) => {
        switch (item.offer) {
            case "Active":
                return (
                    <div className="fake-table-resp">
                        <span className="thead-row">Offer</span>
                        <div className="success fake-td"> Active</div>
                    </div>
                );
            case "Inactive":
                return (
                    <div className="fake-table-resp">
                        <span className="thead-row">Offer</span>
                        <div className="danger fake-td"> Inactive</div>
                    </div>
                );
            default:
                return (
                    <div className="fake-table-resp">
                        <span className="thead-row">Offer</span>
                        <div className="danger fake-td"> Inactive</div>
                    </div>
                );
        }
    };
    const Price = ({item}) => (
        <div className="fake-table-resp">
            <span className="thead-row">Price</span>
            <div className="pricing fake-td ">
                {item?.oldPrice && <p className="old-price">{item?.oldPrice}</p>}
                <p>{item?.price}</p>
            </div>
        </div>
    );
    const ActionBtn = ({item}) => {
        const handleDelete = async () => {
            const res = await menuStoreService.deleteItem(item?._id);
            Toast({
                type: "success",
                message: res?.message,
            });
            refetch();
        };
        return (
            <div className="fake-table-resp">
                <span className="thead-row">Action</span>
                <div className="action-btn">
                    {hasPermission("menu-management.edit-item") && (
                        <ModalContainer
                            width={850}
                            title="Edit Item"
                            btnComponent={({onClick}) => (
                                <button onClick={onClick} className="edit">
                                    <FaRegEdit />
                                </button>
                            )}
                            content={({onClose}) => (
                                <AddNewItem
                                    item={item}
                                    menuId={menuId}
                                    isEdit={true}
                                    btnText="Save Changes"
                                    onClose={onClose}
                                    categoryId={rowData._id}
                                />
                            )}
                        />
                    )}
                    {hasPermission("menu-management.delete-item") && (
                        <div className="delete">
                            <ModalContainer
                                width={450}
                                noBorder
                                // refetch={refetch}
                                btnComponent={({onClick}) => (
                                    <button className="delete-btn" onClick={onClick}>
                                        <img src={deleteIcon} alt="delete-Icon" />
                                    </button>
                                )}
                                content={({onClose}) => (
                                    <DeleteModal
                                        onSubmit={handleDelete}
                                        title="Are you sure you want to Delete this Menu?"
                                        successTitle="Menu Deleted Successfully!"
                                        onClose={onClose}
                                    />
                                )}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    };
    const DragHandle = sortableHandle(() => (
        <div className="fake-table-resp drag-handle2" style={{userSelect: "none"}}>
            <span className="thead-row" style={{userSelect: "none"}}>
                #
            </span>
            <div
                className=""
                style={{
                    marginRight: "10px",
                    cursor: "move",
                    flexShrink: "0",
                }}>
                <img src={handel} alt="handel" />
            </div>
        </div>
    ));

    const SortableItem = sortableElement(({item, index, ...rest}) => (
        <FakeTabelBody key={index}>
            <DragHandle />
            <Items item={item} />
            <Description item={item} />
            <Variation item={item} />
            <Choices item={item} />
            <Status item={item} />
            <Offer item={item} />
            <Price item={item} />
            <ActionBtn item={item} />
        </FakeTabelBody>
    ));
    const SortableContainer = sortableContainer(({children}) => {
        return <TableRowsWrapper>{children}</TableRowsWrapper>;
    });

    const onSortEnd = ({oldIndex, newIndex}) => {
        setProduct(prevState => arrayMove(prevState, oldIndex, newIndex));
        handelApi(arrayMove(product, oldIndex, newIndex), rowData?.categoryName);
    };
    return (
        <>
            <StyledMenuManagementAccor $active={selected === ind} key={ind}>
                <div className="head" onClick={() => handelSelected(ind)}>
                    <div className="main-title">
                        <strong className="title">{rowData?.name}</strong>
                        {hasPermission("menu-management.edit-category") && (
                            <ModalContainer
                                width={850}
                                title="Edit Category"
                                btnComponent={({onClick}) => (
                                    <Button onClick={onClick} className="edit">
                                        <FaRegEdit />
                                        Edit Category
                                    </Button>
                                )}
                                content={({onClose}) => (
                                    <AddCategory
                                        editCategory={true}
                                        categoryData={rowData}
                                        onClose={onClose}
                                        menuId={menuId}
                                    />
                                )}
                            />
                        )}
                        
                    </div>
                    <div className="delete-btn">

                 
                        <ModalContainer
                                width={450}
                                noBorder
                                btnComponent={({onClick}) => (
                                    <button className="delete-btn" onClick={onClick}>
                                        <img src={deleteIcon} alt="delete-category" />
                                    </button>
                                )}
                                content={({onClose}) => {
                                    const handleDeleteCategory = async () => {
                                        const res = await menuStoreService.deleteCategory(rowData?._id);
                                        Toast({
                                            type: "success",
                                            message: res?.message || "Category deleted successfully",
                                        });
                                        refetch();
                                    };
                                    return (
                                        <DeleteModal
                                            onSubmit={handleDeleteCategory}
                                            title="Are you sure you want to Delete this Category?"
                                            successTitle="Category Deleted Successfully!"
                                            onClose={onClose}
                                        />
                                    );
                                }}
                            />
                               <div className={`arrow ${selected === ind && "open"}`}>
                        <TiArrowSortedUp size={22} />
                        
                    </div>
                    </div>
                </div>
                <CategoryBody $active={selected === ind}>
                    <div className="fake-table-header">
                        <span style={{userSelect: "none"}}>#</span>
                        <span>Items</span>
                        <span>Description</span>
                        <span>Variation</span>
                        <span>Choice group</span>
                        <span>Status</span>
                        <span>Offer</span>
                        <span>Price</span>
                        <span>Actions</span>
                    </div>
                    <SortableContainer onSortEnd={onSortEnd} useDragHandle>
                        {product?.map((item, ind) => (
                            <SortableItem item={item} index={ind} />
                        ))}
                    </SortableContainer>
                </CategoryBody>
            </StyledMenuManagementAccor>
        </>
    );
};

export default MenuManagementAccor;
